import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './components/App';
import '@warp-ds/elements';

const el = document.getElementById('content-price-info-root');

if (el) {
  createRoot(el).render(<App
    orgId={Number(el.getAttribute('data-org-id')) || undefined}
    market={el.getAttribute('data-market') || ''}
  />);
}
